import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon, MessageCircleIcon } from 'lucide-react';
const testimonials = [{
  text: <>
        Estábamos al borde de separarnos. Este PDF nos dio{' '}
        <strong data-id="element-303">herramientas concretas</strong> para hablar sin pelear.{' '}
        <em data-id="element-304">En una semana ya se sentía diferente.</em>
      </>,
  author: 'Lucía y Martín',
  location: 'Buenos Aires',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
  isWhatsapp: false
}, {
  text: <>
        Lo mejor es que es <strong data-id="element-305">100% práctico</strong>. No es teoría
        aburrida, son cosas que <em data-id="element-306">aplicas esa misma noche</em>.
      </>,
  author: 'Carolina R.',
  location: 'Córdoba',
  avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
  isWhatsapp: false
}, {
  text: <>
        El Contrato de Convivencia fue un <strong data-id="element-307">antes y un después</strong>.
        Por primera vez sentimos que <em data-id="element-308">somos un equipo</em>.
      </>,
  author: 'Diego y Sofía',
  location: 'Rosario',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  isWhatsapp: false
}];
const whatsappScreenshots = [{
  image: 'https://cdn.magicpatterns.com/uploads/8boRHpSQpv2MeH8mL1TRnq/Diseno_sin_titulo_(8).png'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/tHgnRBo1m5GsuNk4ydSYTZ/Diseno_sin_titulo_(7).png'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/rX5dX2TT97ZRnk14TBT3aF/Diseno_sin_titulo_(6).png'
}];
export function TransformationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#0D002B]" data-id="element-309">
      <div className="max-w-6xl mx-auto px-6" data-id="element-310">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-311">
          <div className="text-center mb-20" data-id="element-312">
            <div className="inline-block bg-[#34D399]/20 text-[#34D399] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-313">
              CASOS REALES
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center font-serif" data-id="element-314">
              Lo que dicen quienes ya lo aplicaron
            </h2>
          </div>

          {/* Regular testimonials */}
          <div className="grid md:grid-cols-3 gap-8 md:gap-10 mb-16" data-id="element-315">
            {testimonials.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.15,
            ease: 'easeOut'
          }} className="bg-[#E0D7FF] rounded-[20px] border border-white p-8 md:p-10 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)] flex flex-col" data-id="element-316">
                <div className="flex gap-1 mb-8" data-id="element-317">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-[#E5A83B] fill-[#E5A83B]" data-id="element-318" />)}
                </div>
                <p className="text-[#1E0A3C] text-lg leading-relaxed mb-10 flex-1 font-sans italic font-medium" data-id="element-319">
                  "{item.text}"
                </p>
                <div className="flex items-center gap-4 mt-auto pt-6 border-t border-[#7C3AED]/20" data-id="element-320">
                  <div className="w-12 h-12 rounded-full flex-shrink-0 overflow-hidden border-2 border-white shadow-sm" data-id="element-321">
                    <img src={item.avatar} alt={item.author} className="w-full h-full object-cover" data-id="element-322" />
                  </div>
                  <div data-id="element-323">
                    <p className="font-bold text-[#1E0A3C] font-sans" data-id="element-324">
                      {item.author}
                    </p>
                    <p className="text-sm text-[#3B1F6E] font-sans" data-id="element-325">
                      {item.location}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* WhatsApp screenshots — capturas reales */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.7,
          delay: 0.5,
          ease: 'easeOut'
        }} data-id="element-326">
            <div className="flex flex-col items-center gap-2 mb-10" data-id="element-327">
              <div className="flex items-center justify-center gap-3" data-id="element-328">
                <MessageCircleIcon className="w-6 h-6 text-[#25D366]" data-id="element-329" />
                <p className="text-[#C4B5FD] font-bold text-lg tracking-wide uppercase text-center" data-id="element-330">
                  Mensajes de quienes ya lo adquirieron
                </p>
              </div>
              <p className="text-[#A78BFA] text-sm italic text-center" data-id="element-331">
                👇 Deslizá para ver más capturas
              </p>
            </div>

            <div className="w-full overflow-x-auto pb-8 snap-x snap-mandatory hide-scrollbar" data-id="element-332">
              <div className="flex gap-6 md:gap-8 w-max px-4 mx-auto" data-id="element-333">
                {whatsappScreenshots.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                scale: 0.95,
                y: 20
              }} animate={isInView ? {
                opacity: 1,
                scale: 1,
                y: 0
              } : {
                opacity: 0,
                scale: 0.95,
                y: 20
              }} transition={{
                duration: 0.6,
                delay: 0.6 + index * 0.15,
                ease: 'easeOut'
              }} whileHover={{
                scale: 1.02,
                y: -4
              }} className="relative bg-[#1a1a2e] rounded-[28px] p-2 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.6)] border-2 border-[#7C3AED]/30 overflow-hidden w-[280px] md:w-[320px] shrink-0 snap-center" data-id="element-334">
                    {/* Phone notch */}
                    <div className="absolute top-2 left-1/2 -translate-x-1/2 w-20 h-5 bg-black rounded-b-2xl z-10" data-id="element-335" />

                    <img src={item.image} alt="Mensaje real de cliente" loading="lazy" className="w-full h-auto rounded-[22px] block" data-id="element-336" />
                  </motion.div>)}
              </div>
            </div>

            <p className="text-center text-[#A78BFA] text-sm mt-4 italic" data-id="element-337">
              💬 <em data-id="element-338">Más de 1.200 parejas ya aplicaron el método.</em>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}